import {Component, EventEmitter, input, Input, OnInit, Output,} from "@angular/core";
import {DateLevelEnum, DateLevelFormat, DateLevelZoom} from "../../date/picker/date-level-enum";

@Component({
    selector: 'yo-date-range-box',
    templateUrl: './date-range-box.component.html',
    styleUrls: ['./date-range-box.component.scss'],
    standalone: false
})

export class DateRangeBoxComponent implements OnInit {
  now : Date = new Date();
  dateEnd : Date  = new Date();

  @Output() onValueChange = new EventEmitter;
  @Input() selectedDates: Date[] = [this.now, this.dateEnd];
  @Input() selectLevel: DateLevelEnum = DateLevelEnum.DAY;
  startDateLabel = input<string>("Début");
  endDateLabel = input<string>("Fin");
  firstDateLastDay = input<boolean>(false);
  lastDateLastDay = input<boolean>(true);

  ngOnInit(): void {}

  onValueChanged = (dates): void => {
    if (dates.event == null)
      return;
    let filterDatesLivraisons: Date[];
    if (dates.value[0]) {
      let startDate: Date = dates.value[0];
      if (this.firstDateLastDay())
        startDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
      let endDate: Date = dates.value[1] ?? dates.value[0];
      const endDateChoisie: boolean = dates.value[1] != null && this.selectLevel === DateLevelEnum.DAY;
      if (this.lastDateLastDay() && !endDateChoisie)
        endDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);
      filterDatesLivraisons = [startDate, endDate];
    } else {
      filterDatesLivraisons = undefined;
    }
    this.onValueChange.emit(filterDatesLivraisons);
  };

  protected readonly DateLevelFormat = DateLevelFormat;
  protected readonly DateLevelZoom = DateLevelZoom;
  protected readonly DateLevelEnum = DateLevelEnum;
}
